export default __webpack_public_path__ + "static/media/T3_04.84a77e3b.jpg";